"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _antd = require("antd");

var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));

var _Select = _interopRequireDefault(require("../Select"));

var _Input = _interopRequireDefault(require("../Input"));

var _redux = require("../../redux");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var LanguageForm = function LanguageForm(props) {
  var _props$language = props.language,
      defaultLanguage = _props$language === void 0 ? {
    id: null,
    name: '',
    slug: '',
    locale: ''
  } : _props$language;

  var _ref = (0, _redux.useAppSelector)(function (state) {
    return state;
  }),
      languages = _ref.cms.languages;

  var dispatch = (0, _redux.useAppDispatch)();

  var _ref2 = (0, _react.useState)(false),
      _ref3 = _slicedToArray(_ref2, 2),
      loading = _ref3[0],
      setLoading = _ref3[1];

  var _ref4 = (0, _react.useState)(defaultLanguage),
      _ref5 = _slicedToArray(_ref4, 2),
      language = _ref5[0],
      setLanguage = _ref5[1];

  (0, _react.useEffect)(function () {
    languages.length === 0 && dispatch(_redux.languageActions.getLanguages());
  }, []);

  var handleChange = function handleChange(e) {
    return setLanguage(_objectSpread(_objectSpread({}, language), {}, _defineProperty({}, e.target.name, e.target.value)));
  };

  var handleUpsert = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var id, name, slug, locale;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              id = language.id, name = language.name, slug = language.slug, locale = language.locale;

              if (!(!name || !slug || !locale)) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return");

            case 3:
              setLoading(true);

              if (!id) {
                _context.next = 9;
                break;
              }

              _context.next = 7;
              return dispatch(_redux.languageActions.updateLanguage({
                id: id,
                name: name,
                slug: slug,
                locale: locale
              }));

            case 7:
              _context.next = 11;
              break;

            case 9:
              _context.next = 11;
              return dispatch(_redux.languageActions.addLanguage({
                name: name,
                slug: slug,
                locale: locale
              }));

            case 11:
              // Reset to default and close modal
              setLanguage({
                id: null,
                name: '',
                slug: '',
                locale: ''
              });
              setLoading(false);
              dispatch(_redux.uiActions.hideDialog());

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleUpsert() {
      return _ref6.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: "vertical",
    size: 20
  }, /*#__PURE__*/_react.default.createElement(_Select.default, {
    showSearch: true,
    optionFilterProp: "children",
    filterOption: function filterOption(input, option) {
      return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    filterSort: function filterSort(optionA, optionB) {
      return optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase());
    },
    value: language.locale,
    onChange: function onChange(value) {
      var selectedLanguage = languages.find(function (o) {
        return o.locale === value;
      }) || {};
      setLanguage(_objectSpread(_objectSpread({}, language), selectedLanguage));
    },
    label: 'Select a language',
    loading: languages.length === 0
  }, languages.map(function (o) {
    return /*#__PURE__*/_react.default.createElement(_antd.Select.Option, {
      key: o.locale,
      value: o.locale,
      children: (0, _htmlReactParser.default)("".concat(o.name, " - ").concat(o.locale))
    });
  })), /*#__PURE__*/_react.default.createElement(_Input.default, {
    label: "Name",
    name: "name",
    value: language.name,
    onChange: handleChange
  }), /*#__PURE__*/_react.default.createElement(_Input.default, {
    label: "Language Code",
    name: "slug",
    value: language.slug,
    onChange: handleChange
  }), /*#__PURE__*/_react.default.createElement(_Input.default, {
    label: "Locale",
    name: "locale",
    value: language.locale,
    disabled: true
  }), /*#__PURE__*/_react.default.createElement(_antd.Button, {
    id: "add-language",
    children: language !== null && language !== void 0 && language.id ? 'Update' : 'Add',
    onClick: handleUpsert,
    type: "primary",
    disabled: !language.name || !language.slug || !language.locale,
    loading: loading
  }));
};

var _default = LanguageForm;
exports.default = _default;